<template>
  <div id="app">
    <menuu ref="menu" :sources="sources"></menuu>

    <div class="d-block d-md-none text-center">
      <a href="https://sibforms.com/serve/MUIFAKSnvgQpfsnGbLvHa1CX-1gntEP4mv5fH7MQD1Rj7-YdrTRbzkxYvyalZ6LbCzxACQY6XNmc-XZhm_M4kpPZW6aIVOTWaZ3BzxeYKImC9wG3wqNXK0qwIuEK35x1HRH_1sok7w0C9U8lCgZu5ndP7SkNqyNnDEVJ8JjBP8huD1fdLHgwoM5otUPrvl37sHzd4vKLL4XPQRDT" class="btn btn-outline-success mt-3">
        Jetzt Newsletter abonnieren
      </a>
    </div>

    <div class="container-fluid pt-3">
      <div class="row">
        <div class="d-none d-xl-block col-xl-2">
          <sidebar-left :sources="sources"></sidebar-left>
        </div>
        <div class="col-12 col-md-8 col-xl-7">
          <router-view id="yield"></router-view>
        </div>
        <div class="col-12 col-md-4 col-xl-3 mt-5 mt-md-0">
          <sidebar-right></sidebar-right>
        </div>
      </div>
    </div>

    <foooter></foooter>

    <update></update>

    <app-download></app-download>
  </div>
</template>

<script>
  import Menuu from '@/vues/shared/menu.vue';
  import Foooter from '@/vues/shared/footer.vue';
  import Update from '@/vues/shared/update.vue';
  import AppDownload from '@/vues/shared/app-download.vue';

  import SidebarLeft from '@/vues/shared/sidebar-left.vue';
  import SidebarRight from '@/vues/shared/sidebar-right.vue';

  export default {
    name: 'App',
    components: { Menuu, Foooter, Update, AppDownload, SidebarLeft, SidebarRight },
    data () {
      return {
        sources: []
      };
    },
    async mounted () {
      const res = await this.$http.get('sources');
      this.sources = res.body;
    }
  };
</script>

<style lang="scss">
  $sizes: (
    25: 25%,
    50: 50%,
    75: 75%,
    100: 100%,
    60px: 60px,
    80px: 80px,
    100px: 100px
  );
  
  @import 'assets/fonts.scss';
  @import 'assets/bootstrap.scss';
  @import '~bootstrap/scss/bootstrap.scss';
  @import '~bootstrap-vue/src/index.scss';

  @each $breakpoint in map-keys($grid-breakpoints) {
    @include media-breakpoint-up($breakpoint) {
      $infix: breakpoint-infix($breakpoint, $grid-breakpoints);
      @each $prop, $abbrev in (width: w, height: h) {
        @each $size, $length in $sizes {
          .#{$abbrev}#{$infix}-#{$size} { #{$prop}: $length !important; }
        }
      }
    }
  }


  @media (hover: none) {
    a:hover {
      text-decoration: none;
    }
  }
</style>

<style lang="less">
  .form-group.required label:after {
    content: "*";
    color: red;
    margin-left: 2px;
  }

  .adspace {
    margin: 0 auto;
    
    ins img {
      width: 100%;
      height: 100%;
    }

    &.s300x100 {
      max-width: 300px;

      ins img {
        max-width: 300px;
        max-height: 100px;
      }
    }

    &.s300x250 {
      max-width: 300px;

      ins img {
        max-width: 300px;
        max-height: 250px;
      }
    }

    &.s728x90 {
      max-width: 728px;

      ins img {
        max-width: 728px;
        max-height: 90px;
      }
    }

    &.s160x600 {
      max-width: 160px;

      ins img {
        max-width: 160px;
        max-height: 600px;
      }
    }
  }
</style>
